<template>
  <div style="display: flex;align-items: center">
    <el-tooltip
      v-show="showWarningImage"
      :content="warningImageTip"
      placement="right-end"
    >
      <i
        class="el-icon-warning red"
        style="cursor: pointer;font-size: 14px;"
      />
    </el-tooltip>
    <el-tooltip
      :disabled="!tooltip || !tooltipContent"
      :content="tooltipContent"
      placement="bottom-end"
    >
      <cargo-advance-select
        ref="company"
        :disabled="disabled"
        :select-type="selectTypeNames.basic_data_Company"
        :method-params="methodParams"
        :headers="headers && headers.length > 0 ? headers : undefined"
        :fields="fields && fields.length > 0 ? fields : undefined"
        :tag-name="tagName"
        filterable
        :default-value="value"
        :placeholder="placeholder || undefined"
        :static-options="staticOptions"
        :data-filter-function="dataFilterFunction"
        @parentCallBack="onParentCallBack"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
        @clear="$emit('clear')"
      />
    </el-tooltip>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { cacheName, cache } from '@/utils/cacheManager'
import { CreditInfo } from '@/class/model/sys/CreditInfo'
import { CreditInfoUtil } from '@/class/cargo/model/utils/CreditInfoUtil'

export default {
  name: 'CompanySelectWithCheck',
  components: { cargoAdvanceSelect },
  props: {
    disabled: { type: Boolean, default: false },
    dataFilterFunction: { type: Function, default: null }, // options项数据过滤函数
    methodParams: { type: Object, default: () => { return {} } },
    value: { type: Number, default: 0 },
    headers: { type: Array, default: () => [] },
    fields: { type: Array, default: () => [] },
    tagName: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    tooltip: { type: Boolean, default: false },
    tooltipTagName: { type: String, default: '' },
    staticOptions: { type: Array, default: null },
    job: { type: Object, default: null },
    showAlert: { type: Boolean, default: false }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      tooltipContent: '',
      showWarningImage: false,
      warningImageTip: '',
      warningValue: 0
    }
  },
  computed: {
    options() {
      return this.$refs.company ? this.$refs.company.options : []
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (!this.tooltip || !this.tooltipTagName) {
          return
        }
        if (newVal) {
          this.tooltipContent = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', newVal, this.tooltipTagName)
        } else {
          this.tooltipContent = ''
        }
        if (this.warningValue !== newVal) {
          this.checkCompany(newVal, false)
        }
      },
      immediate: true
    }
  },
  methods: {
    async onParentCallBack(data) {
      const val = data.value || 0
      if (!await this.checkCompany(val, this.showAlert)) {
        return
      }
      this.$emit('input', val)
      this.$emit('change', val)
    },
    // 验证合作伙伴信控
    async checkCompany(companyId, showAlert) {
      this.showWarningImage = false
      this.warningImageTip = ''
      this.warningValue = companyId
      if (!companyId) return
      await cache.load(cacheName.CONFIG)
      if (parseInt(cache.config.get('creditOpen')) === 1) {
        await CreditInfo.checkCreditInfo(companyId, CreditInfoUtil.getJobData(this.job)).then(res => {
          if (!res.data || res.data.length <= 0) return
          const credit = res.data[0]
          if (credit && credit.blacklist) {
            if (showAlert) {
              this.$message.warning(this.$t('Message.PartnersBeenAddedToBlacklist'))
              return false
            }
          }
          for (const item of res.data) {
            this.setCreditColor(item, showAlert)
          }
        })
      }
      return true
    },
    setCreditColor(credit, showAlert) {
      if (!credit) return
      if (credit.amountExceeded || credit.dateExceeded) {
        let s = ' '
        if (credit.amountExceeded) { s += this.$t('Partners.credit_limit') + ' ' }
        if (credit.dateExceeded) { s += this.$t('Partners.accountPeriod') + ' ' }
        const toolTip = this.$t('Partners.parter') + s + this.$t('SeaExport.HasExceeded')
        if (showAlert) {
          this.$message.warning(toolTip)
        }
        this.showWarningImage = true
        this.warningImageTip = toolTip
      }
    }
  }
}
</script>
